var translator = require('exports-loader?Translator!@BazingaJsTranslationBundle/Resources/public/js/translator.min.js');

export default () => translator;
